export const roundToTwoDecimals = (num) => Math.round(num * 100) / 100
